import { useState, useEffect, useCallback } from 'react';
import type { AuditEntry, PaginationInfo } from '../api/types';
import { fetchAuditLog, type AuditLogParams } from '../api/client';

export function useAuditLog(params: AuditLogParams) {
  const [data, setData] = useState<AuditEntry[]>([]);
  const [pagination, setPagination] = useState<PaginationInfo>({
    page: 1,
    per_page: 50,
    total: 0,
    total_pages: 0,
  });
  const [loading, setLoading] = useState(true);

  const load = useCallback(() => {
    setLoading(true);
    fetchAuditLog(params)
      .then((res) => {
        setData(res.data);
        setPagination(res.pagination);
      })
      .catch(console.error)
      .finally(() => setLoading(false));
  }, [JSON.stringify(params)]);

  useEffect(() => {
    load();
  }, [load]);

  return { data, pagination, loading, reload: load };
}
